// src/components/KursPlanPage.jsx

import React, { useContext, useEffect, useState, useRef } from "react";
import axios from "axios";
import InlineSvg from './InlineSvg';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'; // Импортируем react-
/* import DatePickerSelect from 'react-date-picker'; */
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import Loader from "./Loader";
import { de } from 'date-fns/locale/de';
import "react-datepicker/dist/react-datepicker.css";
import "../styles/KursPlanPage.css"; // Обновлённый файл стилей
import styles from "../styles/KursPlanPage.module.css"; // Обновлённый файл стилей
import placeholder from '../assets/placeholder.svg';

import { ClassContext } from '../contexts/ClassContext';
import { LicenseContext } from '../contexts/LicenseContext';
import { KurseContext } from '../contexts/KurseContext';
import { useKurse } from '../contexts/KurseContext';

import CourseRegistrationModal from "./CourseRegistrationModal";

registerLocale('de', de);

const PAGE_SIZE = 25;

const KursPlanPage = ({smallKursplan, prefilter, selectedClasses, grundwissen, ehk, arzt}) => {
    const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);
    const { license, loadingLicense, errorLicense } = useContext(LicenseContext);
    /* const { kurse, loadingKurse, errorKurse, fetchKurse } = useContext(useKurse); */
    const { kurse, loadingKurse, errorKurse, fetchKurse } = useKurse();

    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;

    /* const [smallKursplan, setSmallKursplan] = useState(false); */
    const [filterOpen, setFilterOpen] = useState(false);
    const [filterTooltipClosed, setFilterTooltipClosed] = useState(false);
    const [isKursartenOpen, setKursartenOpen] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [selectedKursarten, setSelectedKursarten] = useState(0);
    const [selectedKurstypen, setSelectedKurstypen] = useState([]);
    const [selectedClassIds, setSelectedClassIds] = useState(selectedClasses ? selectedClasses : []);
    const [selectedLicense, setSelectedLicense] = useState([]);
    const [selectedOrtes, setSelectedOrtes] = useState([]);
    const [selectedModules, setSelectedModules] = useState([]);
    const [selectedCourseName, setSelectedCourseName] = useState(""); // Новый стейт для выбранного курса
    const [grundwissenOnOff, setGrundwissenOnOff] = useState(grundwissen ? grundwissen : false);
    const [EHKOnOff, setEHKOnOff] = useState(false);
    const [arztOnOff, setArztOnOff] = useState(false);
    const [abendOnOff, setAbendOnOff] = useState(false);
    const [ferienOnOff, setFerienOnOff] = useState(false);
    const [selectedCourseNameModal, setSelectedCourseNameModal] = useState(""); // Новый стейт для выбранного курса
    const [currentPage, setCurrentPage] = useState(1);
    const [termineOpen, setTermineOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [sortKursStart, setSortKursStart] = useState(null); // 'asc' или 'desc'
    const [sortKursEnd, setSortKursEnd] = useState(null); // 'asc' или 'desc'
    const [sortTermineDate, setSortTermineDate] = useState(null); // 'asc' или 'desc'
    const [sortTermineModule, setSortTermineModule] = useState(null); // 'asc' или 'desc'
    const [sortTermineOrt, setSortTermineOrt] = useState(null); // 'asc' или 'desc'
    const [classFilterText, setClassFilterText] = useState(""); // Новый стейт для поиска классов
    const [courseFilterText, setCourseFilterText] = useState(""); // Новый стейт для поиска курсов
    const [filterName, setFilterName] = useState("");

    const [kursartenData, setKursartenData] = useState([]);
    const [loadingKursarten, setLoadingKursarten] = useState(true);
    const [errorKursarten, setErrorKursarten] = useState(null);

    const [isDPOpen, setIsDPOpen] = useState(false);

    const ClassLabels = {
        "theorie_gw": "Theorie",
        "theorie_klasse": "Theorie",
        "praxis": "Praxis",
        "arzt": "Arzt",
        "ehk": "EHK"
    }

    const handleDPChange = (e) => {
        setIsDPOpen(!isDPOpen);
        setStartDate(e);
    };
    const handleDPClick = (e) => {
        e.preventDefault();
        setIsDPOpen(!isDPOpen);
    };

    /* if(selectedClasses) { setSelectedClassIds(selectedClasses); } */
    /* if(grundwissen) { setGrundwissenOnOff(grundwissen); }
    if(ehk) { setEHKOnOff(ehk); } */

    const Kursarten_API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Kursarten?fields=*.*&filter[status][_eq]=published';

    useEffect(() => {
        const fetchKursarten = async () => {
        try {
            const response = await axios.get(Kursarten_API_URL);
            if (response.data && response.data.data) {
                setKursartenData(response.data.data);
            } else {
                setErrorKursarten('Нет данных для отображения');
            }
            } catch (error) {
                setErrorKursarten('Ошибка при получении данных');
                console.error(error);
            } finally {
                setLoadingKursarten(false);
            }
        };

        fetchKursarten();
    }, []);

    const getIconUrl = (icon) => {
        if (!icon || !icon.filename_disk) return null;
        const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
        return `${baseUrl}${icon.filename_disk}`;
    };

    // Состояние для отслеживания раскрытых курсов
    const [expandedCourses, setExpandedCourses] = useState({});
    const [openKurs, setOpenKurs] = useState(new Set());
    const [openKursId, setOpenKursId] = useState(null);

    const [expandedFilters, setExpandedFilters] = useState({
        kurstyp: false,
        classes: false,
        fuehrerscheine: false,
        ort: false,
        modules: false,
        courseName: false,
        sort: false
    });

    const KurstypLabels = {
        "klasse": "Klassenspezifische Kurse",
        "arzt": "Ärztliche Untersuchungen",
        "abend": "Abendkurse",
        "kurz": "Ferien-Kurz-Kurse",
        "ehk": "Erste Hilfe Kurse"
    }


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCourseId, setSelectedCourseId] = useState(null);

    const openModal = (courseId, courseName) => {
        setSelectedCourseId(courseId);
        setSelectedCourseNameModal(courseName);
        setIsModalOpen(true);
    };


    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedCourseId(null);
    };


    const [successMessage, setSuccessMessage] = useState('');
    const handleFormSubmit = (data, message) => {
        console.log('Submitting registration data:', data);
        closeModal();
        setSuccessMessage(message);

        setTimeout(() => {
            setSuccessMessage('');
          }, 3000);

    };

    const toggleFilterOpen = (close) => {
        if(close) {
            setFilterOpen(false);
        } else {
            setFilterOpen(filterOpen => !filterOpen);
            toggleKursartenOpen(true);
            setFilterTooltipClosed(true);
        }
        
    }

    const toggleKursartenOpen = (close) => {
        if(close) {
            setKursartenOpen(false)
        } else {
            setKursartenOpen(isKursartenOpen => !isKursartenOpen);
            toggleFilterOpen(true);
        }
    }

    const toggleFilter = (filterName) => {
        setExpandedFilters(prev => ({
            /* ...prev, */
            [filterName]: !prev[filterName]
        }));
    };

    const openFilter = (filterName) => {
        setExpandedFilters(prev => ({
            [filterName]: true
        }));
    }

    const closeFilter = (filterName) => {
        setExpandedFilters(prev => ({
            [filterName]: false
        }));
    }

    const toggleKurs = (kId) => {
        setOpenKursId(prev => (prev === kId ? null : kId));
        /* setOpenKurs(prev => {
            const newSet = new Set(prev);
            if (newSet.has(kId)) {
                newSet.delete(kId);
            } else {
                newSet.add(kId);
            }
            return newSet;
        }); */
    };

    const toggleGrundwissen = () => {
        setGrundwissenOnOff(grundwissenOnOff => !grundwissenOnOff);
    }

    const toggleEHKOnOff = () => {
        /* handleKursartToggle(4); */
        setEHKOnOff(EHKOnOff => !EHKOnOff);
    }

    const toggleArztOnOff = () => {
        setArztOnOff(arztOnOff => !arztOnOff);
    }

    const toggleAbendOnOff = () => {
        setAbendOnOff(abendOnOff => !abendOnOff);
        /* if(abendOnOff) handleKurstypToggle('abend'); */
        setFerienOnOff(false);

    }

    const toggleFerienOnOff = () => {
        setFerienOnOff(ferienOnOff => !ferienOnOff);
        /* if(ferienOnOff) handleKurstypToggle('kurz'); */
        setAbendOnOff(false);
    }

    const [isNotTop, setIsNotTop] = useState(null);

    const handleScroll = () => {
        const pageYOffset = window.scrollY;

        setIsNotTop(pageYOffset > 0 ? true : false);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Ref для закрытия dropdown при клике вне его
    const dropdownRef = useRef(null);

    useEffect(() => {
        fetchKurse();
    }, [fetchKurse]);

    useEffect(() => {
        // Обработчик клика вне dropdown
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
    if (prefilter === "kurz" && kursartenData.length > 0) {
        const autoKursart = kursartenData.find(k => k.Name?.toLowerCase().includes("auto"));
        if (autoKursart) {
            setSelectedKursarten(autoKursart.id);
        }
        setFerienOnOff(true);
    }
}, [prefilter, kursartenData]);


    /* const handleKursartToggle = (kurstyp) => {
        setSelectedKursart(prev => {
            if (prev.includes(kurstyp)) {
                return prev.filter(ka => ka !== kurstyp);
            } else {
                return [...prev, kurstyp];
            }
        });
        setCurrentPage(1);
    }; */

    const handleKursartToggle = (kursart) => {
        if(selectedKursarten === kursart) {
            setSelectedKursarten(0);
            setFerienOnOff(false);
            setAbendOnOff(false);
            setSelectedKurstypen([]);
        } else {
            setSelectedKursarten(kursart);
            setSelectedClassIds([]);
            setGrundwissenOnOff(false);
            setArztOnOff(false);
            setEHKOnOff(false);
            setFerienOnOff(false);
            setAbendOnOff(false);
            setSelectedModules([]);
            setSelectedOrtes([]);
            setSelectedKurstypen([]);
        }

        kursart === 6 ? openFilter('modules') : closeFilter('modules');

        toggleKursartenOpen(true);
        setCurrentPage(1);
    };

    /* const handleKursartToggle = (kursart) => {
        setSelectedKursarten(prev => {
            if (prev.includes(kursart)) {
                return prev.filter(ka => ka !== kursart);
            } else {
                return [...prev, kursart];
            }
        });
        setCurrentPage(1);
    }; */

    console.log(selectedKursarten)

    const handleDateChange = (date) => {
        setStartDate(date);
        setIsDPOpen(false);
        setCurrentPage(1);
    };

    const handleKurstypToggle = (kurstyp) => {
        setSelectedKurstypen(kurstyp);
        setCurrentPage(1);
    };

    /* const handleKurstypToggle = (kurstyp) => {
        setSelectedKurstypen(prev => {
            if (prev.includes(kurstyp)) {
                return prev.filter(kt => kt !== kurstyp);
            } else {
                return [...prev, kurstyp];
            }
        });
        setCurrentPage(1);
    }; */

    const handleClassToggle = (klasseId) => {
        setSelectedClassIds(prev => {
            if (prev.includes(klasseId)) {
                return prev.filter(id => id !== klasseId);
            } else {
                return [...prev, klasseId];
            }
        });
        setCurrentPage(1);
    };

    const handleLicenseToggle = (id, Name, Klassen) => {
        setSelectedLicense(prev => {
            if (prev.map(p => p.id).includes(id)) {
                return prev.filter(lId => lId.id !== id);
            } else {
                return [...prev, {id, Name, Klassen}];
            }
        });
        setCurrentPage(1);
    };

    const handleOrtToggle = (ortName) => {
        setSelectedOrtes(prev => {
            if (prev.includes(ortName)) {
                return prev.filter(o => o !== ortName);
            } else {
                return [...prev, ortName];
            }
        });
        setCurrentPage(1);
    };

    const handleModuleToggle = (moduleName) => {
        setSelectedModules(prev => {
            if (prev.includes(moduleName)) {
                return prev.filter(m => m !== moduleName);
            } else {
                return [...prev, moduleName];
            }
        });
        setCurrentPage(1);
    };

    const toggleDropdown = () => {
        setDropdownOpen(prev => !prev);
    };

    const handleCourseExpansion = (kursId) => {
        setExpandedCourses(prev => ({
            ...prev,
            [kursId]: !prev[kursId]
        }));
    };

    const handleSortKursStart = () => {
        setSortKursStart(prev => (prev === 'asc' ? 'desc' : 'asc'));
    };

    const handleSortKursEnd = () => {
        setSortKursEnd(prev => (prev === 'asc' ? 'desc' : 'asc'));
    };

    const handleSortTermineDate = () => {
        setSortTermineOrt(false);
        setSortTermineModule(false);
        setSortTermineDate(prev => (prev === 'asc' ? 'desc' : 'asc'));
    };

    const handleSortTermineModule = () => {
        setSortTermineDate(false);
        setSortTermineOrt(false);
        setSortTermineModule(prev => (prev === 'asc' ? 'desc' : 'asc'));
    };

    const handleSortTermineOrt = () => {
        setSortTermineDate(false);
        setSortTermineModule(false);
        setSortTermineOrt(prev => (prev === 'asc' ? 'desc' : 'asc'));
    };

    /* const groupByKursart = (kursarten) => {
        return kursarten.reduce((acc, kursart) => {
            kursart.forEach((kategorieRelation) => {
                const categoryName = kategorieRelation.Kategorien_id?.Name || "Keine Kategorie";

                // Исключаем категорию "Anhänger", если нужно
                if (categoryName.toLowerCase() === 'anhänger') {
                    return;
                }

                if (!acc[categoryName]) {
                    acc[categoryName] = [];
                }
                acc[categoryName].push(kursart);
            });
            return acc;
        }, {});
    };
    const groupedKursarten = groupByKursart(klassen); */

    // Фильтрация курсов
    let filteredKurse = kurse;

    if (loadingKlassen) {
        /* return <p>Loading Klassen ...</p>; */
        return <Loader />;
    }
    if (errorKlassen) {
        return <p className="error">{errorKlassen}</p>;
    }

    if (loadingKurse) {
        /* return <p>Loading Kurse ...</p>; */
        return <Loader />;
    }
    if (errorKurse) {
        return <p className="error">{errorKurse}</p>;
    }

    //Kurz-Kurse!
    // if (pathname === '/kurzkurse') {
    //     /* setSelectedKurstypen('kurz'); */
    //     filteredKurse = filteredKurse.filter((kurs) => kurs.Kurstyp === 'kurz');
    // }

    console.log(selectedKursarten);
    // Фильтрация по выбранным местам проведения (Ort)
    /* if (selectedKursarten.length > 0) {
        filteredKurse = filteredKurse.filter((kurs) =>
            selectedKursarten.includes(kurs.Kursart?.id)
        );
    } */

    if (selectedKursarten > 0) {

        filteredKurse = filteredKurse.filter((kurs) =>
            kurs.Kursart?.id === selectedKursarten
        );
    }

    if(startDate) {
        filteredKurse = filteredKurse.filter((kurs) =>
            new Date(kurs.Ende) >= startDate
        );
    }

    // Фильтрация по выбранным местам проведения (Ort)
    if (ferienOnOff) {
        filteredKurse = filteredKurse.filter((kurs) =>
            kurs.Kurstyp?.includes('kurz')
        );
    }

    if (abendOnOff) {
        filteredKurse = filteredKurse.filter((kurs) =>
            kurs.Kurstyp?.includes('abend')
        );
    }

    // Фильтрация по выбранным классам
    if (selectedClassIds.length > 0) {
        if (grundwissenOnOff) {
            filteredKurse = filteredKurse.filter((kurs) =>
                kurs.Termine?.some((termin) =>
                    termin.Modul?.Klassen?.some(k => selectedClassIds.includes(k.Klassen_id)) && !termin.Modul?.Typ?.includes('theorie_gw')
                )
            );
        } else {
            filteredKurse = filteredKurse.filter((kurs) =>
                kurs.Termine?.some((termin) =>
                    termin.Modul?.Klassen?.some(k => selectedClassIds.includes(k.Klassen_id))
                )
            );
        }
    }

    console.log(selectedLicense);
    if (selectedLicense.length > 0) {
        if (grundwissenOnOff) {
            filteredKurse = filteredKurse.filter((kurs) =>
                kurs.Termine?.some((termin) =>
                    termin.Modul?.Klassen?.some(l => selectedLicense.map(sl => sl.Klassen?.map(k => k.id).includes(l.id))) && !termin.Modul?.Typ?.includes('theorie_gw')
                )
            );
        } else {
            filteredKurse = filteredKurse.filter((kurs) =>
                kurs.Termine?.some((termin) =>
                    termin.Modul?.Klassen?.some(l => selectedLicense.map(sl => sl.Klassen?.map(k => k.id).includes(l.id)))
                )
            );
        } 
    }

    if (grundwissenOnOff) {
        filteredKurse = filteredKurse.filter((kurs) =>
            kurs.Termine?.some((termin) =>
                !termin.Modul?.Typ?.includes('theorie_gw')
            )
        );
    }

    if (EHKOnOff) {
        filteredKurse = filteredKurse.filter((kurs) =>
            kurs.Termine?.some((termin) =>
                !termin.Modul?.Typ?.includes('ehk')
            )
        );
    }

    if (arztOnOff) {
        filteredKurse = filteredKurse.filter((kurs) =>
            kurs.Termine?.some((termin) =>
                !termin.Modul?.Typ?.includes('arzt')
            )
        );
    }

    // Фильтрация по выбранным местам проведения (Ort)
    if (selectedOrtes.length > 0) {
        filteredKurse = filteredKurse.filter((kurs) =>
            // selectedOrtes.includes(kurs.Kursort.Kurzname)
            kurs.Termine?.some((termin) =>
                selectedOrtes.includes(termin.Ort?.Ort)
            )
        );
    }

    // Фильтрация по выбранным модулям
    if (selectedModules.length > 0) {
        filteredKurse = filteredKurse.filter((kurs) =>
            kurs.Termine?.some((termin) =>
                selectedModules.includes(termin.Modul?.Name)
            )
        );
    }

    // Фильтрация по выбранному имени курса (dropdown)
    if (selectedCourseName !== "") {
        filteredKurse = filteredKurse.filter((kurs) =>
            kurs.Name === selectedCourseName
        );
    }

    // Сортировка курсов по дате начала
    if (sortKursStart) {
        filteredKurse = filteredKurse.slice().sort((a, b) => {
            const dateA = new Date(a.Start);
            const dateB = new Date(b.Start);
            return sortKursStart === 'asc' ? dateA - dateB : dateB - dateA;
        });
    }

    // Сортировка курсов по дате окончания
    if (sortKursEnd) {
        filteredKurse = filteredKurse.slice().sort((a, b) => {
            const dateA = new Date(a.Ende);
            const dateB = new Date(b.Ende);
            return sortKursEnd === 'asc' ? dateA - dateB : dateB - dateA;
        });
    }

    const groupByCategory = (klassen) => {
        return klassen.reduce((acc, klasse) => {
            const kategorien = klasse.Kategorien || [];
            kategorien.forEach((kategorieRelation) => {
                const categoryName = kategorieRelation.Kategorien_id?.Name || "Keine Kategorie";

                // Исключаем категорию "Anhänger", если нужно
                if (categoryName.toLowerCase() === 'anhänger') {
                    return;
                }

                if (!acc[categoryName]) {
                    acc[categoryName] = [];
                }
                acc[categoryName].push(klasse);
            });
            return acc;
        }, {});
    };

    const groupedKlassen = groupByCategory(klassen);

    const availableKursarten = [...new Set(kurse.flatMap(kurs => 
        kurs.Kursart
    ))].filter(Boolean);

    console.log(selectedKursarten);

    const selectedKurse = [...new Set(kurse.filter((kurs) =>
        selectedKursarten ? kurs.Kursart?.id === selectedKursarten : []
    ))].filter(Boolean);


    console.log(selectedKurse);
    // Получение уникальных модулей
    const availableModules = [...new Set(selectedKurse.flatMap(kurs =>
        kurs.Termine ? kurs.Termine.filter((termin) => termin.Modul?.indexierbar === true).map(termin => termin.Modul?.Name) : []
    ))].filter(Boolean)
        .slice().sort((a, b) => {
            const intA = parseInt(a.replace(/[^0-9]/g, ''), 10);
            const intB = parseInt(b.replace(/[^0-9]/g, ''), 10);

            return (
                (b == null) - (a == null)
                || (intA - intB)
                || (a > b) - (b > a)
            )
        });

    const availableLicenses = [...new Set(filteredKurse.flatMap(kurs =>
        kurs.Termine ? kurs.Termine.map(termin => termin.Modul?.Thema) : []
    ))].filter(Boolean);

    // Получение уникальных модулей
    const availableKurstypen = [...new Set(filteredKurse.flatMap(kurs => kurs.Kurstyp))].filter(Boolean);

    /* const availableKursarten = [...new Set(kurse.flatMap(kurs =>
        kurs ? kurs.map(k => k.Kursart) : []
    ))].filter(Boolean); */

    // Получение уникальных мест проведения (Orte)
    /// Kursorte
    // const availableOrtes = [...new Set(kurse.map(kurs => kurs.Kursort?.Kurzname)).values()].filter(Boolean);
    const availableOrtes = [...new Set(kurse.flatMap(kurs =>
        kurs.Termine ? kurs.Termine.map(termin => termin.Ort?.Ort) : []
    ))].filter(Boolean);

    console.log(availableModules);
    console.log(availableOrtes);

    // Получение уникальных названий курсов для dropdown
    const availableCourseNames = [...new Set(kurse.map(kurs => kurs.Name))].filter(Boolean);

    // Пагинация
    const totalPages = Math.ceil(filteredKurse.length / PAGE_SIZE);
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    const endIndex = startIndex + PAGE_SIZE;
    const kursePage = filteredKurse.slice(startIndex, endIndex);
    const mainElement = document.getElementById('kursplan-container');

    const goToPreviousPage = () => {
        mainElement.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
        });
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };
    const goToNextPage = () => {
        mainElement.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
        });
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    const goToNPage = (i) => {
        mainElement.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
        });
        setCurrentPage(i);
    };

    /* const renderUniqueModules = (kurs) => {
        if (!kurs.Termine || kurs.Termine.length === 0)
            return true;
    }
 */

    const getFilteredTermine = (termine) => {

        // Фильтрация Termine/Module по выбранным классам, Ort и модулям
        let filteredTermine = termine;

        if (selectedClassIds.length > 0) {
            filteredTermine = filteredTermine.filter((termin) =>
                termin.Modul?.Klassen?.some(k => selectedClassIds.includes(k.Klassen_id))
            );
        }

        if (selectedOrtes.length > 0) {
            filteredKurse = filteredKurse.filter((kurs) =>
                selectedOrtes.includes(kurs.Kursort?.Kurzname)
            );
        }

        if (selectedModules.length > 0) {
            filteredTermine = filteredTermine.filter((termin) =>
                selectedModules.includes(termin.Modul?.Name)
            );
        }

        if (grundwissenOnOff) {
            filteredTermine = filteredTermine.filter((termin) =>
                !termin.Modul?.Typ.includes('theorie_gw')
            );
        }

        return filteredTermine;
    }
    // Функция для рендеринга Termine/Module
    const renderTermineModule = (kurs) => {
        if (!kurs.Termine || kurs.Termine.length === 0)
            return <tr><td colSpan={6}>Keine Termine</td></tr>;

        // Фильтрация Termine/Module по выбранным классам, Ort и модулям
        let filteredTermine = getFilteredTermine(kurs.Termine);

        if (selectedClassIds.length > 0) {
            filteredTermine = filteredTermine.filter((termin) =>
                termin.Modul?.Klassen?.some(k => selectedClassIds.includes(k.Klassen_id))
            );
        }

        if (selectedOrtes.length > 0) {
            /* filteredKurse = filteredKurse.filter((kurs) =>
                selectedOrtes.includes(kurs.Kursort?.Kurzname)
            ); */
            filteredTermine = filteredTermine.filter((termin) =>
                selectedOrtes.includes(termin.Ort?.Ort)
            );
        }

        if (selectedModules.length > 0) {
            filteredTermine = filteredTermine.filter((termin) =>
                selectedModules.includes(termin.Modul?.Name)
            );
        }

        if (grundwissenOnOff) {
            filteredTermine = filteredTermine.filter((termin) =>
                !termin.Modul?.Typ.includes('theorie_gw')
            );
        }

        // Сортировка модулей по дате (Datum + Start)
        if (sortTermineDate) {
            filteredTermine = filteredTermine.slice().sort((a, b) => {
                // Создаём полные даты для сравнения
                const dateA = new Date(`${a.Datum}T${a.Start}`);
                const dateB = new Date(`${b.Datum}T${b.Start}`);
                return sortTermineDate === 'asc' ? dateA - dateB : dateB - dateA;
            });
        }

        if (sortTermineModule) {
            filteredTermine = filteredTermine.slice().sort((a, b) => {
                const modulA = a.Modul.Name;
                const modulB = b.Modul.Name;
                const intA = parseInt(a.Modul.Name.replace(/[^0-9]/g, ''), 10);
                const intB = parseInt(b.Modul.Name.replace(/[^0-9]/g, ''), 10);
                console.log(intA, intB);
                return sortTermineModule === 'asc' ? (
                    (modulB == null) - (modulA == null)
                    || (intA - intB)
                    || (modulA > modulB) - (modulB > modulA)
                ) : (
                    (modulA == null) - (modulB == null)
                    || (intB - intA)
                    || (modulB > modulA) - (modulA > modulB)
                )
                    /* (modulA > modulB ? 1 : -1)
                    : (modulB > modulA ? 1 : -1); */
            });
        }

        if (sortTermineOrt) {
            filteredTermine = filteredTermine.slice().sort((a, b) => {
                return sortTermineOrt === 'asc' ? (a.Ort.Kurzname > b.Ort.Kurzname ? 1 : -1) : (b.Ort.Kurzname > a.Ort.Kurzname ? 1 : -1);
            });
        }

        /* (filteredTermine.length === 1) ? setTermineOpen(true) : setTermineOpen(false); */

        if (filteredTermine.length === 0)
            return <tr><td colSpan={6}>Keine Termine</td></tr>;

        return filteredTermine.map((t) => {
            return (
                <div className={`termin-row ${startDate > new Date(t.Start_cal) ? 'disabled' : ''}`} key={t.id}>
                    <div className="termin-date">
                        {new Date(t.Datum).toLocaleDateString('de-AT', { day: '2-digit', month: 'short', year: 'numeric' })}
                    </div>
                    <div className="termin-time">
                        {new Date(t.Start_cal).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' })}
                        <span className="timeline"></span>
                        {new Date(t.Ende_cal).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' })}
                    </div>
                    <div className="termin-modul">{t.Modul?.Name}</div>
                    <div className="termin-lektion">
                        <span className={`label ${t.Modul?.Typ}`}>{ClassLabels[t.Modul?.Typ]}</span>
                        {t.Modul?.Typ === "theorie_gw" ? (
                            <span className={`label label_gw`}>Grundwissen</span>
                        ) : ''}
                        {t.Modul?.Thema.length > 0 && t.Modul?.Thema.map((thm) => (
                            (t.Modul.Typ === "theorie_klasse") || (t.Modul.Typ === "praxis") ? (
                                <span key={thm.id} className={`label ${t.Modul.Typ} label_klasse`}>{thm.Fuehrerscheine_id.Name}</span>
                            ) : ''
                        ))}
                    </div>
                    <div className="termin-ort">{t.Ort?.Kurzname}</div>
                </div>
            );
        });
    };

    // Функция для создания опций для react-select
    // const createCourseOptions = () => {
    //     return availableCourseNames.map((kursName) => ({
    //         value: kursName,
    //         label: kursName
    //     }));
    // };

    const createCourseOptions = () => {
        // Если путь /kurzkurse, то отфильтровать только курсы с Ferienkurs === true
        const coursesToUse = pathname === '/kurzkurse'
            ? kurse.filter(kurs => kurs.Ferienkurs === true)
            : kurse;

        // Получить уникальные названия курсов
        const uniqueNames = [...new Set(coursesToUse.map(kurs => kurs.Name))].filter(Boolean);

        return uniqueNames.map((kursName) => ({
            value: kursName,
            label: kursName
        }));
    };





    return (
        <div className="kurs-plan-page">
            {!smallKursplan && (
                <header className="kurs-plan-header">
                    {/* <div className="container">
                        <button onClick={() => navigate(-1)} className="back-button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" /></svg>
                        </button>
                        <h2 className={hideSubtitle ? 'hidden' : ''}>Hier findest du unseren</h2>

                        {pathname === '/kurzkurse' ? (
                            <h1>Ferien Kurz-Kurse Klasse B & Termine</h1>
                        ) : (
                            <h1>Kursplan</h1>
                        )}
                    </div> */}
                    <div className="kursart-filter">
                        <div className="kursart-selected">
                            <button
                                className={`kursart-all ${selectedKursarten === 0 ? 'active' : ''}`}
                                onClick={() => handleKursartToggle(0)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M150-331q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h246q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm0-165q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h413q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm0-165q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h413q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm501.87 448q-5.87 0-10.87-2-5-2-10-7l-94-94q-9-9-9-21t9-21q9-9 21.47-9.5 12.46-.5 21.53 8.5l72 72 164-164q8.8-9 20.9-8.5 12.1.5 21.49 9.5 8.61 9 8.61 21.5t-9 21.5L673-222q-5 5-10.13 7-5.14 2-11 2Z"/></svg>
                                <div>
                                    <span className="kursart-all-title">Alle anzeigen</span>
                                    <span>oder wähle eine Kursart</span>
                                </div>
                            </button>
                        </div>
                        {!loadingKursarten && !errorKursarten && (
                            <>
                                <button 
                                    className={`kursart-menu-btn ${isKursartenOpen ? 'active' : ''}`}
                                    onClick={() => toggleKursartenOpen()}
                                >
                                    {selectedKursarten !== 0 ? (
                                        kursartenData.filter((kursart) => kursart.id === selectedKursarten)
                                            .map((kursart) => {
                                                const iconUrl = getIconUrl(kursart.Icon);
                                                return (
                                                    <div className="selected-kursart" key={kursart.id}>
                                                        {iconUrl ? (
                                                            iconUrl.endsWith('.svg') ? (
                                                                <InlineSvg
                                                                src={iconUrl}
                                                                alt={kursart.Name}
                                                                className="kursart-icon"
                                                                fallback={placeholder}
                                                                />
                                                            ) : (
                                                                <img
                                                                src={iconUrl}
                                                                alt={kursart.Name}
                                                                className="kursart-icon"
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = {placeholder};
                                                                }}
                                                                />
                                                            )
                                                        ) : (
                                                            <div className="kursart-icon-placeholder" />
                                                        )}
                                                        <span>{kursart.Name}</span>
                                                    </div>
                                                )
                                            })
                                    ) : (
                                        "Kursart auswählen"
                                    )}
                                    
                                </button>
                                <nav className={`kursart-nav-container ${isKursartenOpen ? 'open' : ''}`} onClick={() => toggleKursartenOpen(true)}>
                                    <ul className="kursart-dropdown">
                                        {kursartenData.map((kursart, index) => {
                                            const iconUrl = getIconUrl(kursart.Icon);
                                            /* const iconUrl = kursart.Icon; */
                                            return (
                                                <li key={index}>
                                                    <button
                                                        className={`${selectedKursarten === kursart.id ? 'active' : ''}`}
                                                        onClick={() => handleKursartToggle(kursart.id)}
                                                    >
                                                        {iconUrl ? (
                                                            iconUrl.endsWith('.svg') ? (
                                                                <InlineSvg
                                                                    src={iconUrl}
                                                                    alt={kursart.Name}
                                                                    className="kursart-icon"
                                                                    fallback={placeholder}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={placeholder}
                                                                    alt={kursart.Name}
                                                                    className="kursart-icon"
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = {placeholder};
                                                                }}
                                                                />
                                                            )
                                                        ) : (
                                                            <div className="kursart-icon-placeholder" />
                                                        )}
                                                        <span>{kursart.Name}</span>
                                                    </button>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </nav>
                            </>
                        )}
                    </div>
                </header>
            )}

            <main id="kursplan" className="kursplan">
                {!smallKursplan && (
                    <>
                        <button 
                            className={`filter-btn ${ filterOpen ? 'accept' : ''}`}
                            onClick={() => toggleFilterOpen()} 
                            role="button"
                        >
                            {filterOpen ? (
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m382-354 339-339q12-12 28-12t28 12q12 12 12 28.5T777-636L410-268q-12 12-28 12t-28-12L182-440q-12-12-11.5-28.5T183-497q12-12 28.5-12t28.5 12l142 143Z"/></svg>
                            ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-120q-17 0-28.5-11.5T440-160v-160q0-17 11.5-28.5T480-360q17 0 28.5 11.5T520-320v40h280q17 0 28.5 11.5T840-240q0 17-11.5 28.5T800-200H520v40q0 17-11.5 28.5T480-120Zm-320-80q-17 0-28.5-11.5T120-240q0-17 11.5-28.5T160-280h160q17 0 28.5 11.5T360-240q0 17-11.5 28.5T320-200H160Zm160-160q-17 0-28.5-11.5T280-400v-40H160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520h120v-40q0-17 11.5-28.5T320-600q17 0 28.5 11.5T360-560v160q0 17-11.5 28.5T320-360Zm160-80q-17 0-28.5-11.5T440-480q0-17 11.5-28.5T480-520h320q17 0 28.5 11.5T840-480q0 17-11.5 28.5T800-440H480Zm160-160q-17 0-28.5-11.5T600-640v-160q0-17 11.5-28.5T640-840q17 0 28.5 11.5T680-800v40h120q17 0 28.5 11.5T840-720q0 17-11.5 28.5T800-680H680v40q0 17-11.5 28.5T640-600Zm-480-80q-17 0-28.5-11.5T120-720q0-17 11.5-28.5T160-760h320q17 0 28.5 11.5T520-720q0 17-11.5 28.5T480-680H160Z"/></svg>
                            )}
                        </button>
                        <button
                            className={`filter-reset ${ filterOpen ? 'active' : ''}`}
                            onClick={() => {
                                setSelectedKurstypen([]);
                                setSelectedClassIds([]);
                                setSelectedOrtes([]);
                                setSelectedModules([]);
                                setSelectedCourseName("");
                                setSortKursStart(null);
                                setSortKursEnd(null);
                                setSortTermineDate(null);
                                setClassFilterText("");
                                setCourseFilterText("");
                                setCurrentPage(1);
                                toggleFilterOpen();
                            }}
                            role="button"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z"/></svg>
                        </button>
                    </>
                )}
                {/* Блок с классами и дополнительными фильтрами */}

                {!smallKursplan && (
                    <div className={`filter-container ${filterOpen ? 'open' : ''}`} /* onClick={() => toggleFilterOpen(true)} */>
                        <div className={`filter-tooltip ${filterTooltipClosed ? 'closed' : ''} ${isNotTop ? 'closed' : ''}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z"/></svg>
                            <span>Hier kannst du die Kurse filtern, die du für deine(n) Führerschein(e) benötigst!</span>
                            <button role="button" className="close-button" onClick={() => setFilterTooltipClosed(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z"/></svg>
                            </button>
                        </div>
                        <aside id="filter" className={`${filterOpen ? 'open' : ''}`}>
                            <div className={`filters-container ${selectedKursarten <= 0 ? 'open' : ''}`}>
                                <div className="filters-items">
                                    <div className="filter-section">
                                        <div className="filter-header">
                                            <h4>Welche(n) Führerschein(e) möchtest du machen?</h4>
                                            <div className="info-container" onClick={({target}) => target.classList.toggle('active')} onBlur={({target}) => target.classList.toggle('active', true)}>
                                                <svg className="info-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                                                <div className="info-popup">
                                                    <p>Markiere einfach deine gewünschten Klassen und wir suchen dir alle Kurse raus die du für deinen Führerschein benötigst.</p>
                                                    <p>Du kannst bei uns auch mehere Führerscheine auf einmal in Form einer Kombi machen.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <p>In nur 3 Schritten zu allen Kursen die du für deine Ausbildung benötigst</p> */}
                                        {/* <div className="filter-section">
                                            test
                                        </div> */}
                                        <div className="klassen-labels">
                                            {klassen
                                                .filter((value, index, self) => index === self.findIndex((t) => (t.Klassenkuerzel === value.Klassenkuerzel)) )
                                                .filter((klasse) => klasse.Klassenkuerzel !== null)
                                                .filter((klasse) => klasse.Klassenkuerzel.toLowerCase().includes(classFilterText.toLowerCase()))
                                                .filter((klasse) => klasse.Module.length > 0)
                                                .map((klasse) => 
                                                    <label key={klasse.id} className={`klassen-label ${selectedClassIds.includes(klasse.id) ? 'selected' : ''}`}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedClassIds.includes(klasse.id)}
                                                            onChange={() => handleClassToggle(klasse.id)}
                                                        />
                                                        {klasse.Klassenkuerzel}
                                                    </label>
                                                )}
                                        </div>
                                    </div>
                                    <div className={`filter-section ${expandedFilters.classes ? 'open' : ''}`} style={{display: 'none'}}>
                                        <div
                                            onClick={() => toggleFilter('classes')}
                                            className="filter-title"
                                            role="button"
                                            tabIndex={0}
                                            onKeyPress={(e) => { if (e.key === 'Enter') toggleFilter('classes') }}
                                        >
                                            <span>{selectedClassIds.length > 0 ? selectedClassIds.map((id) => klassen.find((kl) => kl.id == id).Name).join(', ') : 'Klassen auswählen'}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                        </div>
                                        {expandedFilters.classes && (
                                            <div className="filter-dropdown">
                                                {/* <input
                                                type="text"
                                                placeholder="Klassen suchen..."
                                                value={classFilterText}
                                                onChange={(e) => setClassFilterText(e.target.value)}
                                                className="class-search-input"
                                            /> */}
                                                <div className="filter-options">
                                                    {/* <button
                                                        onClick={() => setSelectedClassIds(klassen.map(k => k.id))}
                                                        className="select-all-button"
                                                    >
                                                        Alle auswählen
                                                    </button>
                                                    <button
                                                        onClick={() => setSelectedClassIds([])}
                                                        className="deselect-all-button"
                                                    >
                                                        Alles abwählen
                                                    </button> */}
                                                </div>
                                                <div className="checkbox-group">
                                                    {/* {Object.keys(klassen).map((category) => (
                                                        <div key={category} className="checkbox-category">
                                                            <strong>{category}</strong> */}
                                                            <div className="checkbox-options">
                                                                {klassen
                                                                    .filter((value, index, self) => index === self.findIndex((t) => (t.Name === value.Name)) )
                                                                    .filter((klasse) => klasse.Name.toLowerCase().includes(classFilterText.toLowerCase()))
                                                                    .filter((klasse) => klasse.Module.length > 0)
                                                                    .map((klasse) => (
                                                                        <label key={klasse.id} className="checkbox-label">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selectedClassIds.includes(klasse.id)}
                                                                                onChange={() => handleClassToggle(klasse.id)}
                                                                            />
                                                                            {klasse.Name}
                                                                        </label>
                                                                    ))}
                                                            </div>
                                                        {/* </div>
                                                    ))} */}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="toggle-section">
                                        <span className="toggle-label">Hast du schon einen Führerschein?</span>
                                        <div className="info-container" onClick={({target}) => target.classList.toggle('active')}>
                                            <svg className="info-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                                            <div className="info-popup">
                                                <p>Wenn du bereits einen Führerschein (außer AM) besitzt, hast du das Grundwissen schon einmal absolviert und brauchst es bei weiteren Klassen nicht mehr wiederholen.</p>
                                            </div>
                                        </div>
                                        <button 
                                            onClick={() => toggleGrundwissen()}
                                            className={`toggle-switch ${grundwissenOnOff ? 'on' : 'off'}`}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <input type="checkbox"></input>
                                            <div className="toggle-slider"></div>
                                            <span className="toggle-on">Ja</span>
                                            <span className="toggle-off">Nein</span>
                                        </button>
                                    </div>
                                    <div className="toggle-section">
                                        <span className="toggle-label">Hast du schon einen Erste Hilfe Kurs?</span>
                                        <div className="info-container" onClick={({target}) => target.classList.toggle('active')}>
                                            <svg className="info-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                                            <div className="info-popup">
                                                <p>Für deine gewählten Führerscheine ist ein 6-stündiger Erste Hilfe Kurs von Nöten.</p>
                                                <p>Hast du diesen schon absolviert ist er unbegrenzt gültig</p>
                                            </div>
                                        </div>
                                        <button 
                                            onClick={() => toggleEHKOnOff()}
                                            className={`toggle-switch ${EHKOnOff ? 'on' : 'off'}`}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <input type="checkbox"></input>
                                            <div className="toggle-slider"></div>
                                            <span className="toggle-on">Ja</span>
                                            <span className="toggle-off">Nein</span>
                                        </button>
                                    </div>
                                    <div className="toggle-section">
                                        <span className="toggle-label">Hast du schon eine Ärztliche Bestätigung?</span>
                                        <div className="info-container" onClick={({target}) => target.classList.toggle('active')}>
                                            <svg className="info-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                                            <div className="info-popup">
                                                <p>Für deine gewählte Ausbildung ist ein ärztliches Gutachten nötig.</p>
                                                <p>Dieses Gutachten ist nur 18 Monate gültig.</p>
                                            </div>
                                        </div>
                                        <button 
                                            onClick={() => toggleArztOnOff()}
                                            className={`toggle-switch ${arztOnOff ? 'on' : 'off'}`}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <input type="checkbox"></input>
                                            <div className="toggle-slider"></div>
                                            <span className="toggle-on">Ja</span>
                                            <span className="toggle-off">Nein</span>
                                        </button>
                                    </div>
                                </div>
                                {/* 1. Wähle eine Kategorie<br />
                                2. Wähle deine Führerscheinklasse<br />
                                3. Wähle eine Ausbildung */}
                            </div>

                            <div className={`filters-container open`}>
                                <div className="filters-items">
                                    <div className={`filter-section open`}>
                                        <h4>Wann möchtest du starten?</h4>
                                        {/* <div className={`filter-title filter-date ${isDPOpen ? 'open' : ''}`} onClick={handleDPClick}>
                                            <span>{startDate.toLocaleDateString('de-AT', { day: '2-digit', month: 'long', year: 'numeric' })}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                        </div> */}
                                        {/* {isDPOpen && ( */}
                                            <DatePicker
                                                /* className={`filter-title filter-date ${isDPOpen ? 'open' : ''}`} */
                                                locale="de"
                                                selected={startDate}
                                                onChange={handleDateChange}
                                                dateFormat="dd.MM.yyyy"
                                                todayButton="Auf Heute zurücksetzen"
                                                minDate={new Date()}
                                                /* inline */
                                                withPortal
                                                portalId="datepicker-portal"
                                                onBeforeInput={(e) => {
                                                    e.preventDefault();
                                                }}
                                            />
                                        {/* )} */}
                                    </div>

                                    {/* Фильтр по Ort */}
                                        {availableOrtes.length > 1 && (
                                            <div className={`filter-section ${expandedFilters.ort ? 'open' : ''}`}>
                                                <div
                                                    onClick={() => toggleFilter('ort')}
                                                    className="filter-title"
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyPress={(e) => { if (e.key === 'Enter') toggleFilter('ort') }}
                                                >
                                                    <span>{selectedOrtes.length > 0 ? selectedOrtes.join(', ') : 'Ort auswählen'}</span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                                </div>
                                                {expandedFilters.ort && (
                                                    <div className="filter-dropdown">
                                                        <div className="checkbox-group">
                                                            {availableOrtes.map((ort, index) => (
                                                                <label key={index} className="checkbox-label">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedOrtes.includes(ort)}
                                                                        onChange={() => handleOrtToggle(ort)}
                                                                    />
                                                                    {ort}
                                                                </label>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                    {selectedKursarten > 0 && (
                                        <>

                                    {(availableKurstypen.includes('abend') || availableKurstypen.includes('kurz')) && (
                                        <div className="toggle-section">
                                            <span className="toggle-label">Nur Ferien-Kurz-Kurse anzeigen?</span>
                                            <div className="info-container" onClick={({target}) => target.classList.toggle('active')}>
                                                <svg className="info-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                                                <div className="info-popup">
                                                    <p>Ferien-Kurz-Kurse können innerhalb kurzer Zeit abgeschlossen werden und finden in der Regel von 16:15 bis 19:55 statt.</p>
                                                </div>
                                            </div>
                                            <button 
                                                onClick={() => toggleFerienOnOff()}
                                                className={`toggle-switch ${ferienOnOff ? 'on' : 'off'}`}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                <input type="checkbox"></input>
                                                <div className="toggle-slider"></div>
                                                <span className="toggle-on">Ja</span>
                                                <span className="toggle-off">Nein</span>
                                            </button>
                                        </div>
                                    )}
                                    {(availableKurstypen.includes('abend') || availableKurstypen.includes('kurz')) && (
                                        <div className="toggle-section">
                                            <span className="toggle-label">Nur Abendkurse anzeigen?</span>
                                            <div className="info-container" onClick={({target}) => target.classList.toggle('active')}>
                                                <svg className="info-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                                                <div className="info-popup">
                                                    <p>Abendkurse finden in der Regel über einen längeren Zeitraum täglich von 18:15 bis 19:55 statt.</p>
                                                </div>
                                            </div>
                                            <button 
                                                onClick={() => toggleAbendOnOff()}
                                                className={`toggle-switch ${abendOnOff ? 'on' : 'off'}`}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                <input type="checkbox"></input>
                                                <div className="toggle-slider"></div>
                                                <span className="toggle-on">Ja</span>
                                                <span className="toggle-off">Nein</span>
                                            </button>
                                        </div>
                                    )}
                                        {/* <div className={`filter-section ${expandedFilters.kurstyp ? 'open' : ''}`}>
                                            <div
                                                onClick={() => toggleFilter('kurstyp')}
                                                className="filter-title"
                                                role="button"
                                                tabIndex={0}
                                                onKeyPress={(e) => { if (e.key === 'Enter') toggleFilter('classes') }}
                                            >
                                                <span>{selectedKurstypen.length > 0 ? selectedKurstypen.join(', ') : 'Kurstyp auswählen'}</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                            </div>
                                            {expandedFilters.kurstyp && (
                                                <div className="filter-dropdown">
                                                    <input
                                                    type="text"
                                                    placeholder="Klassen suchen..."
                                                    value={classFilterText}
                                                    onChange={(e) => setClassFilterText(e.target.value)}
                                                    className="class-search-input"
                                                />
                                                    <div className="filter-options">
                                                        <button
                                                            onClick={() => setSelectedClassIds(klassen.map(k => k.id))}
                                                            className="select-all-button"
                                                        >
                                                            Alle auswählen
                                                        </button>
                                                        <button
                                                            onClick={() => setSelectedClassIds([])}
                                                            className="deselect-all-button"
                                                        >
                                                            Alles abwählen
                                                        </button>
                                                    </div>
                                                    <div className="checkbox-group">
                                                        {availableKurstypen.map((kurstyp, index) => (
                                                            <label key={index} className="checkbox-label">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedKurstypen.includes(kurstyp)}
                                                                    onChange={() => handleKurstypToggle(kurstyp)}
                                                                />
                                                                {KurstypLabels[kurstyp]} ({kurstyp.toUpperCase()})
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div> */}
                                        {/* Фильтр по классам */}
                                        <div className={`filter-section ${expandedFilters.classes ? 'open' : ''}`} style={{display:'none'}}>
                                            <div
                                                onClick={() => toggleFilter('classes')}
                                                className="filter-title"
                                                role="button"
                                                tabIndex={0}
                                                onKeyPress={(e) => { if (e.key === 'Enter') toggleFilter('classes') }}
                                            >
                                                <span>{selectedClassIds.length > 0 ? selectedClassIds.join(', ') : 'Klassen auswählen'}</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                            </div>
                                            {expandedFilters.classes && (
                                                <div className="filter-dropdown">
                                                    {/* <input
                                                    type="text"
                                                    placeholder="Klassen suchen..."
                                                    value={classFilterText}
                                                    onChange={(e) => setClassFilterText(e.target.value)}
                                                    className="class-search-input"
                                                /> */}
                                                    <div className="filter-options">
                                                        <button
                                                            onClick={() => setSelectedClassIds(klassen.map(k => k.id))}
                                                            className="select-all-button"
                                                        >
                                                            Alle auswählen
                                                        </button>
                                                        <button
                                                            onClick={() => setSelectedClassIds([])}
                                                            className="deselect-all-button"
                                                        >
                                                            Alles abwählen
                                                        </button>
                                                    </div>
                                                    <div className="checkbox-group">
                                                        {Object.keys(groupedKlassen).map((category) => (
                                                            <div key={category} className="checkbox-category">
                                                                <strong>{category}</strong>
                                                                <div className="checkbox-options">
                                                                    {groupedKlassen[category]
                                                                        .filter((klasse) => klasse.Name.toLowerCase().includes(classFilterText.toLowerCase()))
                                                                        .filter((klasse) => klasse.Module.length > 0)
                                                                        .map((klasse) => (
                                                                            <label key={klasse.id} className="checkbox-label">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedClassIds.includes(klasse.id)}
                                                                                    onChange={() => handleClassToggle(klasse.id)}
                                                                                />
                                                                                {klasse.Name}
                                                                            </label>
                                                                        ))}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className={`filter-section ${expandedFilters.fuehrerscheine ? 'open' : ''}`} style={{display:'none'}}>
                                            <div
                                                onClick={() => toggleFilter('fuehrerscheine')}
                                                className="filter-title"
                                                role="button"
                                                tabIndex={0}
                                                onKeyPress={(e) => { if (e.key === 'Enter') toggleFilter('fuehrerscheine') }}
                                            >
                                                <span>{selectedLicense.length > 0 ? selectedLicense.map(l => l.Name).join(', ') : 'Klassen auswählen'}</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                            </div>
                                            {expandedFilters.fuehrerscheine && (
                                                <div className="filter-dropdown">
                                                    {/* <input
                                                    type="text"
                                                    placeholder="Klassen suchen..."
                                                    value={classFilterText}
                                                    onChange={(e) => setClassFilterText(e.target.value)}
                                                    className="class-search-input"
                                                /> */}
                                                    <div className="filter-options">
                                                        <button
                                                            onClick={() => setSelectedClassIds(klassen.map(k => k.id))}
                                                            className="select-all-button"
                                                        >
                                                            Alle auswählen
                                                        </button>
                                                        <button
                                                            onClick={() => setSelectedClassIds([])}
                                                            className="deselect-all-button"
                                                        >
                                                            Alles abwählen
                                                        </button>
                                                    </div>
                                                    <div className="checkbox-group">
                                                        <div className="checkbox-options">
                                                            {license
                                                                /* .filter((klasse) => klasse.Name.toLowerCase().includes(classFilterText.toLowerCase())) */
                                                                .map((license, idx) => (
                                                                    <label key={license.id} className="checkbox-label">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedLicense.map(l => l.id).includes(license.id)}
                                                                            onChange={() => handleLicenseToggle(license.id, license.Name, license.Klassen)}
                                                                        />
                                                                        {license.Name}
                                                                    </label>
                                                                ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Фильтр по модулям с поиском */}
                                        {availableModules.length > 1 && (
                                            <div className={`filter-section ${expandedFilters.modules ? 'open' : ''}`}>
                                                <div
                                                    onClick={() => toggleFilter('modules')}
                                                    className="filter-title"
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyPress={(e) => { if (e.key === 'Enter') toggleFilter('modules') }}
                                                >
                                                    <span>{selectedModules.length > 0 ? selectedModules.join(', ') : (selectedKursarten === 6 ? 'Mehrphase auswählen' : 'Module auswählen')}</span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                                </div>
                                                {expandedFilters.modules && (
                                                    <div className="filter-dropdown">
                                                        {/* <input
                                                            type="text"
                                                            placeholder="Modul suchen..."
                                                            value={filterName}
                                                            onChange={(e) => setFilterName(e.target.value)}
                                                            className="module-search-input"
                                                        /> */}
                                                        <div className="checkbox-group">
                                                            {availableModules
                                                                .filter(module => module.toLowerCase().includes(filterName.toLowerCase()))
                                                                .map((module, index) => (
                                                                    <label key={index} className="checkbox-label">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedModules.includes(module)}
                                                                            onChange={() => handleModuleToggle(module)}
                                                                        />
                                                                        {module}
                                                                    </label>
                                                                ))}
                                                        </div>
                                                        {/* <div className="filter-options">
                                                            <button
                                                                onClick={() => setSelectedModules(availableModules)}
                                                                className="select-all-button"
                                                            >
                                                                Alle auswählen
                                                            </button>
                                                            <button
                                                                onClick={() => setSelectedModules([])}
                                                                className="deselect-all-button"
                                                            >
                                                                Alles abwählen
                                                            </button>
                                                        </div> */}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        </>)}
                                        {/* Сброс всех фильтров */}
                                        {/* <div className="filter-section reset-section">
                                            <button onClick={() => {
                                                setSelectedKurstypen([]);
                                                setSelectedClassIds([]);
                                                setSelectedOrtes([]);
                                                setSelectedModules([]);
                                                setSelectedCourseName("");
                                                setSortKursStart(null);
                                                setSortKursEnd(null);
                                                setSortTermineDate(null);
                                                setClassFilterText("");
                                                setCourseFilterText("");
                                                setCurrentPage(1);
                                            }} className="reset-button">
                                                Filter zurücksetzen
                                            </button>
                                        </div> */}
                                    </div>

                                {/* Фильтр по имени курса (Dropdown с поиском) */}
                                <div className={`filter-section ${expandedFilters.courseName ? 'open' : ''}`} style={{display: 'none'}}>
                                    <div
                                        onClick={() => toggleFilter('courseName')}
                                        className="filter-title"
                                        role="button"
                                        tabIndex={0}
                                        onKeyPress={(e) => { if (e.key === 'Enter') toggleFilter('courseName') }}
                                    >
                                        <span>Suche nach Kurs</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                    </div>
                                    {expandedFilters.courseName && (
                                        <div className="filter-dropdown">
                                            <Select
                                                value={createCourseOptions().find(option => option.value === selectedCourseName) || null}
                                                onChange={(selectedOption) => {
                                                    setSelectedCourseName(selectedOption ? selectedOption.value : "");
                                                    setCurrentPage(1);
                                                }}
                                                options={createCourseOptions()}
                                                isClearable
                                                placeholder="Alle Kurse"
                                                className="course-select-dropdown"
                                            />
                                        </div>
                                    )}
                                </div>


                                {/* Фильтр сортировки */}
                                {/* <div className={`filter-section ${expandedFilters.sort ? 'open' : ''}`}>
                                    <div
                                        onClick={() => toggleFilter('sort')}
                                        className="filter-title"
                                        role="button"
                                        tabIndex={0}
                                        onKeyPress={(e) => { if (e.key === 'Enter') toggleFilter('sort') }}
                                    >
                                        <span>Sortieren</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z" /></svg>
                                    </div>
                                    {expandedFilters.sort && (
                                        <div className="sort-buttons">
                                            <button onClick={handleSortKursStart} className="sort-button">
                                                Kurs Start: {sortKursStart === 'asc' ? '↑ Aufsteigend' : sortKursStart === 'desc' ? '↓ Absteigend' : 'Keine Sortierung'}
                                            </button>

                                            <button onClick={handleSortTermineDate} className="sort-button">
                                                Termin Datum: {sortTermineDate === 'asc' ? '↑ Aufsteigend' : sortTermineDate === 'desc' ? '↓ Absteigend' : 'Keine Sortierung'}
                                            </button>
                                        </div>
                                    )}
                                </div> */}

                                <div className="filter-section" style={{display:'none'}}>
                                    <div className="filter-title">
                                        <span>Grundwissen?</span>
                                        <button 
                                            onClick={() => toggleGrundwissen()}
                                            className={`toggle-switch ${grundwissenOnOff ? 'on' : 'off'}`}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <input type="checkbox"></input>
                                            <div className="toggle-slider"></div>
                                            <span className="toggle-on">Ja</span>
                                            <span className="toggle-off">Nein</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-info">
                                <p>Termine für B/L 17-Einweisungen, PC- und Fahrprüfungen sind nur für angemeldete Schüler zugänglich</p>
                                <a className="button" href="https://fs16a.mmm-software.at:1016/orange/schueler" target="_blank" rel="noreferrer">Zum Schüler-Login</a>
                            </div>
                        </aside>
                    </div>
                )}

                {/* Таблица с курсами и пагинация */}
                <div className="courses-table-container" id="kursplan-container">
                    <div>
                        <div className="termine-header">
                            <div onClick={handleSortTermineDate} className={sortTermineDate === 'asc' ? 'sort' : sortTermineDate === 'desc' ? 'sort sort-desc' : ''}>Datum</div>
                            <div>Uhrzeit</div>
                            <div onClick={handleSortTermineOrt} className={sortTermineOrt === 'asc' ? 'sort' : sortTermineOrt === 'desc' ? 'sort sort-desc' : ''}>Standort</div>
                            <div onClick={handleSortTermineModule} className={sortTermineModule === 'asc' ? 'sort' : sortTermineModule === 'desc' ? 'sort sort-desc' : ''}>Modul</div>
                            <div>Lektion</div>
                        </div>
                        <div>
                            {kursePage.length === 0 ? (
                                <div>
                                    <h3>Es wurden keine Kurse gefunden</h3>
                                    <p>Versuche die Filtereinstellungen anzupassen oder zurück zu stellen.</p>
                                </div>
                            ) : (
                                kursePage.map((kurs) => {
                                    const hasTermine = kurs.Termine && kurs.Termine.length > 0;
                                    const isSingleton = kurs.Termine.length === 1;

                                    const kursId = kurs.id;
                                    /* const isOpen = openKurs.has(kursId); */
                                    const isOpen = openKursId === kursId;

                                    /* const kursStartTag = new Date(kurs.Start).toLocaleString('de-AT', { day: '2-digit' }) || "Unbekannt"
                                    const kursStart = new Date(kurs.Start).toLocaleString('de-AT', { day: '2-digit', month: 'short', year: 'numeric' }) || "Unbekannt";
                                    const kursEnde = new Date(kurs.Ende).toLocaleString('de-AT', { day: '2-digit', month: 'short', year: 'numeric' }) || "Unbekannt";
                                    const kursStartTime = new Date(kurs.Start).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }) || "Unbekannt";
                                    const kursEndeTime = new Date(kurs.Ende).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }) || "Unbekannt"; */

                                    const kursTermine = getFilteredTermine(kurs.Termine);

                                    const maxDate = kursTermine.reduce(function (a, b) { return a.Start_cal > b.Start_cal ? a : b; });
                                    const minDate = kursTermine.reduce(function (a, b) { return a.Ende_cal < b.Ende_cal ? a : b; });

                                    const startDateTag = startDate.toLocaleString('de-AT', { day: '2-digit', month: 'short', year: 'numeric' });

                                    const kursStartTag = new Date(minDate.Start_cal).toLocaleString('de-AT', { day: '2-digit' }) || "Unbekannt";
                                    const kursStart = new Date(minDate.Start_cal).toLocaleString('de-AT', { day: '2-digit', month: 'short', year: 'numeric' }) || "Unbekannt";
                                    const kursEnde = new Date(maxDate.Ende_cal).toLocaleString('de-AT', { day: '2-digit', month: 'short', year: 'numeric' }) || "Unbekannt";
                                    const kursStartTime = new Date(minDate.Start_cal).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }) || "Unbekannt";
                                    const kursEndeTime = new Date(maxDate.Ende_cal).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }) || "Unbekannt";

                                    return (
                                        <div key={kurs.id} className={`kurs-item ${isSingleton ? 'is-single-item' : ''} ${isOpen ? 'open' : ''} ${(startDate.getTime() >= new Date(maxDate.Ende_cal).getTime())  ? 'hidden' : ''}`}>
                                            <div
                                                className="kurs-header"
                                                onClick={() => toggleKurs(kursId)}
                                                aria-expanded={isOpen}
                                                role="button"
                                                tabIndex="0"
                                            >
                                                <div>
                                                    <h3>{kurs.Name} <span>{kurs.Untertitel}</span></h3>
                                                    {/* { renderUniqueModules(kurs) } */}
                                                    <div className="kurs-infos">
                                                        <div className="kurs-termin-counter">
                                                            { kursTermine.length }
                                                            <span>{kurs.Termine.length === 1 ? ' Modul' : ' Module'}</span>
                                                        </div>
                                                        <div className="kurs-date">
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--primary)"><path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-188.5-11.5Q280-423 280-440t11.5-28.5Q303-480 320-480t28.5 11.5Q360-457 360-440t-11.5 28.5Q337-400 320-400t-28.5-11.5ZM640-400q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-188.5-11.5Q280-263 280-280t11.5-28.5Q303-320 320-320t28.5 11.5Q360-297 360-280t-11.5 28.5Q337-240 320-240t-28.5-11.5ZM640-240q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z"/></svg>
                                                            { new Date(kurs.Start).getMonth() === new Date(kurs.Ende).getMonth() ? (
                                                                kursEnde === kursStart ? kursStart : `${kursStartTag}. — ${kursEnde}`
                                                                ) : ( 
                                                                    `${kursStart} — ${kursEnde}` 
                                                                )
                                                            }
                                                        </div>
                                                        {isSingleton && (
                                                            <div className="kurs-time">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--primary)"><path d="M339.5-108.5q-65.5-28.5-114-77t-77-114Q120-365 120-440t28.5-140.5q28.5-65.5 77-114t114-77Q405-800 480-800t140.5 28.5q65.5 28.5 114 77t77 114Q840-515 840-440t-28.5 140.5q-28.5 65.5-77 114t-114 77Q555-80 480-80t-140.5-28.5ZM480-440Zm112 168 56-56-128-128v-184h-80v216l152 152ZM224-866l56 56-170 170-56-56 170-170Zm512 0 170 170-56 56-170-170 56-56ZM480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720q-117 0-198.5 81.5T200-440q0 117 81.5 198.5T480-160Z"/></svg>
                                                                {kursStartTime}
                                                                <span className="timeline"></span>
                                                                {kursEndeTime}
                                                            </div>
                                                        )}
                                                        {kurs.Kursort && (
                                                            <div className="kurs-ort">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--primary)"><path d="M536.5-503.5Q560-527 560-560t-23.5-56.5Q513-640 480-640t-56.5 23.5Q400-593 400-560t23.5 56.5Q447-480 480-480t56.5-23.5ZM480-186q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z"/></svg>
                                                                {kurs.Kursort?.Kurzname}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className={`checkmark ${isOpen ? 'open' : ''}`}>
                                                    { kurs.Plaetze != null && kurs.Plaetze < 3 ? (
                                                        <svg className="plaetze" xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#E35169"><path d="M479.99-280q15.01 0 25.18-10.15 10.16-10.16 10.16-25.17 0-15.01-10.15-25.18-10.16-10.17-25.17-10.17-15.01 0-25.18 10.16-10.16 10.15-10.16 25.17 0 15.01 10.15 25.17Q464.98-280 479.99-280Zm-31.32-155.33h66.66V-684h-66.66v248.67ZM480.18-80q-82.83 0-155.67-31.5-72.84-31.5-127.18-85.83Q143-251.67 111.5-324.56T80-480.33q0-82.88 31.5-155.78Q143-709 197.33-763q54.34-54 127.23-85.5T480.33-880q82.88 0 155.78 31.5Q709-817 763-763t85.5 127Q880-563 880-480.18q0 82.83-31.5 155.67Q817-251.67 763-197.46q-54 54.21-127 85.84Q563-80 480.18-80Zm.15-66.67q139 0 236-97.33t97-236.33q0-139-96.87-236-96.88-97-236.46-97-138.67 0-236 96.87-97.33 96.88-97.33 236.46 0 138.67 97.33 236 97.33 97.33 236.33 97.33ZM480-480Z"/></svg>
                                                    ) : kurs.Plaetze != null &&  kurs.Plaetze < 10 ? (
                                                        <svg className="plaetze" xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#f39200"><path d="M448.67-280h66.66v-240h-66.66v240Zm31.32-316q15.01 0 25.18-9.97 10.16-9.96 10.16-24.7 0-15.3-10.15-25.65-10.16-10.35-25.17-10.35-15.01 0-25.18 10.35-10.16 10.35-10.16 25.65 0 14.74 10.15 24.7 10.16 9.97 25.17 9.97Zm.19 516q-82.83 0-155.67-31.5-72.84-31.5-127.18-85.83Q143-251.67 111.5-324.56T80-480.33q0-82.88 31.5-155.78Q143-709 197.33-763q54.34-54 127.23-85.5T480.33-880q82.88 0 155.78 31.5Q709-817 763-763t85.5 127Q880-563 880-480.18q0 82.83-31.5 155.67Q817-251.67 763-197.46q-54 54.21-127 85.84Q563-80 480.18-80Zm.15-66.67q139 0 236-97.33t97-236.33q0-139-96.87-236-96.88-97-236.46-97-138.67 0-236 96.87-97.33 96.88-97.33 236.46 0 138.67 97.33 236 97.33 97.33 236.33 97.33ZM480-480Z"/></svg>
                                                    ) : '' }
                                                    { isSingleton && (kurs.Plaetze >= 3 || kurs.Plaetze === null ) ? (
                                                        /* <button className="small button pagelink"
                                                            onClick={(e) => {
                                                                e.stopPropagation(); // Останавливаем всплытие события
                                                                openModal(kurs.id, kurs.Name);
                                                            }} style={{ marginBottom: '0' }}>
                                                            Platz reservieren
                                                        </button> */
                                                        ""
                                                    ) : (
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m480-453-95-95q-11-11-27.5-11T329-548q-12 12-12 28.5t12 28.5l123 123q12 12 28 12t28-12l124-124q12-12 11.5-28T631-548q-12-11-28-11.5T575-548l-95 95Zm0 373q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                                    )}

                                                </div>
                                                {/* {!isSingleton && (
                                                    <div className="kurs-details">
                                                        { (kurs.Plaetze >= 3 || kurs.Plaetze === null ) && (
                                                            <button className="small button pagelink"
                                                                onClick={(e) => {
                                                                    e.stopPropagation(); // Останавливаем всплытие события
                                                                    openModal(kurs.id, kurs.Name);
                                                                }} style={{ marginBottom: '0' }}>
                                                                Platz reservieren
                                                            </button>
                                                        )}
                                                        { kurs.Plaetze != null && kurs.Plaetze < 3 ? (
                                                            <div className="plaetze-error">Kurs ist leider ausgebucht</div>
                                                        ) : kurs.Plaetze != null && kurs.Plaetze < 10 ? (
                                                            <div className="plaetze-warning">Nur noch wenige Plätze frei</div>
                                                        ) : '' }
                                                    </div>
                                                )} */}
                                            </div>
                                            {hasTermine && !isSingleton && (
                                                <div className={`termine-container ${isOpen || termineOpen ? 'open' : ''}`}>
                                                    {renderTermineModule(kurs)}
                                                </div>
                                            )}

                                        </div>
                                    );

                                })

                            )}
                        </div>

                    </div>

                    {/* Пагинация */}
                    {totalPages > 1 && (
                        <div className="pagination">
                            <button className="next-page" onClick={() => goToPreviousPage()} disabled={currentPage === 1}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)"><path d="m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"/></svg>
                                {/* Vorherige */}
                            </button>
                            <ul className="page-links">
                                { Array.from({length: totalPages}, (e, i) => (
                                    <li key={i}>
                                        
                                        <button 
                                            className={`${(currentPage === i+1) ? 'current' : ''}`}
                                            onClick={() => goToNPage(i+1)}
                                        >{i+1}</button>
                                    </li>
                                ))}
                            </ul>
                            {/* <span className="page-info">Seite {currentPage} von {totalPages}</span> */}
                            <button className="previous-page" onClick={goToNextPage} disabled={currentPage === totalPages}>
                                {/* Nächste */}
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)"><path d="M647-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h447L451-716q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l264 264q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L508-188q-11 11-27.5 11T452-188q-12-12-12-28.5t12-28.5l195-195Z"/></svg>
                            </button>
                        </div>
                    )}
                </div>
            </main>
            {successMessage && <p className={styles['success-message']}>{successMessage}</p>}

            <CourseRegistrationModal
                isOpen={isModalOpen}
                courseId={selectedCourseId}
                courseName={selectedCourseNameModal}
                onClose={closeModal}
                onSubmit={handleFormSubmit}
            />

            <div id="datepicker-portal"></div>
        </div>
    );
};

export default KursPlanPage;
